export default function rlxWatchGrid() {
    const PRODUCTS_PER_LOAD = 6;
    let currentIndex = 0;
    const watchGridComponents = Array.from(document.querySelectorAll('.js--rlx-v7-watch-grid'));
    if (!watchGridComponents.length) return;

    watchGridComponents.forEach((watchGridComponent) => {
        if (watchGridComponent.hasAttribute('data-is-initialised')) return;

        watchGridComponent.setAttribute('data-is-initialised', '');
        const hiddenProducts = Array.from(watchGridComponent.querySelectorAll('.js--watch-grid-product-item._d-none'));
        if (!hiddenProducts.length) return;
        const showMoreButton = watchGridComponent.querySelector('.js--watch-grid-button');
        if (!showMoreButton) return;

        showMoreButton.addEventListener('click', () => {
            const nextIndex = currentIndex + PRODUCTS_PER_LOAD;

            hiddenProducts.slice(currentIndex, nextIndex).forEach((product) => {
                product.classList.remove('_d-none');
            });

            currentIndex += PRODUCTS_PER_LOAD;

            if (currentIndex >= hiddenProducts.length) {
                showMoreButton.setAttribute('aria-expanded', 'true');
                showMoreButton.classList.add('_d-none');
            } else {
                showMoreButton.setAttribute('aria-expanded', 'false');
            }
        });
    });
}
